import React from "react";
import * as styles from "./SidebarLinks.module.css";
import { Link } from "../../components/elements/Link/Link";
import { PageLink, Video } from "../../types";
import VideoPlayer from "../../components/elements/VideoPlayer/VideoPlayer";

interface SidebarLinkProps {
  links?: PageLink[];
  videos?: Video[];
  heading: string;
}

const SidebarLinks: React.FC<SidebarLinkProps> = ({
  links,
  videos,
  heading,
}) => (
  <div className={styles.container}>
    <h2>{heading}</h2>
    <ul>
      {links &&
        links.map((link) => (
          <li key={link.id}>
            <Link
              to={link.href}
              target={link.target}
              className="scale-transform"
            >
              {link.label}
            </Link>
          </li>
        ))}
      {videos &&
        videos.map((video) => (
          <div className={styles.video} key={video.videoUrl}>
            <div className={styles.videoContainer}>
              <VideoPlayer
                src={video.videoUrl}
                display="overlay"
                thumbnail={video?.thumbnail?.item?.url || true}
                className={`${styles.player} scale-transform-center`}
              />
            </div>
            <p>{video.description}</p>
          </div>
        ))}
    </ul>
  </div>
);

export default SidebarLinks;
